import { render, staticRenderFns } from "./waste.vue?vue&type=template&id=3a9234ed"
import script from "./waste.vue?vue&type=script&lang=js"
export * from "./waste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports